module.exports = __webpack_public_path__ + "static/Glober_xBold-f71785352e1dc19918b1e804e3f97fa2.woff";